import { Div, Heading, Img, Section, Text } from "../../styles/base.style";
import { ButtonPurchaseTransparent } from "../../pages/Home/home.style";
import { memo } from "react";

function SectionRecommend({text_editor, general}) {
    let {related_themes} = text_editor
    let {enable, 
         background_image, 
         small_text, 
         heading_text, 
         image, 
         image_direct_link, 
         button_text, 
         button_link} = related_themes

    if (!enable) return null;

    return (
        <Section id="about-ss" p="120px 0" 
                               backgroundImage={`url(${background_image})`} 
                               backgroundSize="cover" 
                               backgroundRepeat="no-repeat" 
                               backgroundPosition="center" >
            <Div className="container">
                <Div className="row">
                    <Div className="col-md-6" mb={['30px', '30px', 0]}>
                        { image_direct_link && 
                            <a href={image_direct_link} target="_blank" rel="noopener noreferrer">
                                <Img position="relative" zIndex="2" src={image} alt="related theme" />
                            </a>
                        }
                    </Div>
                    <Div className="col-md-6" pl={['15px', '15px', '60px']}>
                        {small_text && <Text color="white" fontSize="18px" fontWeight="500">{small_text}</Text>}

                        {heading_text && <Heading color="white" fontSize="36px" mb="24px">{heading_text}</Heading>}

                        { button_link && button_text && 
                            <ButtonPurchaseTransparent mt="10px" target="_blank" href={button_link}>{button_text}</ButtonPurchaseTransparent>
                        }
                    </Div>
                </Div>
            </Div>
        </Section>
    )
}

export default memo(SectionRecommend);
